import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const milestones = [
  { icon: '⚓', key: 'founder.milestone1' },
  { icon: '🏆', key: 'founder.milestone2' },
  { icon: '⛵', key: 'founder.milestone3' },
  { icon: '🚀', key: 'founder.milestone4' },
];

const pillars = [
  { icon: '🧠', key: 'founder.pillar1' },
  { icon: '⚙️', key: 'founder.pillar2' },
  { icon: '🌊', key: 'founder.pillar3' },
  { icon: '🏇', key: 'founder.pillar4' },
];

export function FounderSection() {
  const { t } = useLanguage();

  return (
    <section id="founder" className="py-24 bg-gradient-to-br from-surface-dark via-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Badge */}
        <div className="text-center mb-16">
          <span className="inline-block bg-primary/20 border border-primary/30 text-primary text-sm font-semibold px-4 py-1.5 rounded-full uppercase tracking-wide mb-6">
            {t('founder.badge')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('founder.title')}
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            {t('founder.subtitle')}
          </p>
        </div>

        {/* Main content */}
        <div className="grid lg:grid-cols-2 gap-16 items-start mb-20">

          {/* Left — bio */}
          <div>
            {/* Avatar placeholder with initials */}
            <div className="flex items-center gap-5 mb-8">
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-primary to-accent flex items-center justify-center text-3xl font-bold text-white shadow-lg flex-shrink-0">
                JF
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">Jerónimo Furtado</h3>
                <p className="text-primary font-medium">Founder & CEO — AiLosofy</p>
                <p className="text-slate-400 text-sm">San Fernando, Buenos Aires · Argentina</p>
              </div>
            </div>

            <p className="text-slate-300 text-lg leading-relaxed mb-6">
              {t('founder.bio1')}
            </p>
            <p className="text-slate-300 leading-relaxed mb-6">
              {t('founder.bio2')}
            </p>
            <p className="text-slate-300 leading-relaxed">
              {t('founder.bio3')}
            </p>
          </div>

          {/* Right — milestones */}
          <div className="space-y-4">
            <h4 className="text-slate-400 text-sm font-semibold uppercase tracking-widest mb-6">
              {t('founder.timelineTitle')}
            </h4>
            {milestones.map((m, i) => (
              <div
                key={i}
                className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-xl p-4 hover:bg-white/10 transition-colors duration-200"
              >
                <span className="text-2xl flex-shrink-0 mt-0.5">{m.icon}</span>
                <p className="text-slate-300 text-sm leading-relaxed">{t(m.key)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Pillars */}
        <div className="border-t border-white/10 pt-16">
          <h4 className="text-center text-slate-400 text-sm font-semibold uppercase tracking-widest mb-10">
            {t('founder.pillarsTitle')}
          </h4>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((p, i) => (
              <div
                key={i}
                className="text-center bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-200"
              >
                <div className="text-3xl mb-3">{p.icon}</div>
                <p className="text-slate-300 text-sm leading-relaxed">{t(p.key)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="#get-started"
            className="inline-block bg-primary hover:bg-primary-dark text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-primary/30"
          >
            {t('founder.cta')}
          </a>
        </div>

      </div>
    </section>
  );
}